import React, { useState } from 'react';
import { Card, CardBody, FormGroup, Label, Input, Button, Row, ButtonGroup } from 'reactstrap';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
const AIInstructionsModule = ({
  allProperties,
  saveIntegration,
  botSettings,
}) => {
  const [instructions, setInstructions] = useState(
    botSettings?.aiInstructions || ''
  );
  const handleInstructionsChange = (e) => {
    setInstructions(e.target.value);
  };

  const handleSave = () => {
    // Save logic here
    botSettings.aiInstructions = instructions;
    saveIntegration({ botSetting: botSettings });
  };

  return (
    <Card className="mb-4">
      <CardBody>
        <div className="text-center mb-2">
          <h6>AI Instructions</h6>
        </div>
        <Separator className="mb-3" />
        <FormGroup>
          <Input
            type="textarea"
            name="aiInstructions"
            id="aiInstructions"
            value={instructions}
            onChange={handleInstructionsChange}
            placeholder="Enter AI instructions here..."
          />
        </FormGroup>
        <Colxx className="text-center">
          <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
            <Button color="primary" size="xs" outline onClick={handleSave}>
              Save
            </Button> 
          </ButtonGroup>
        </Colxx>
      </CardBody>
    </Card>
  );
};

export default AIInstructionsModule;
